import { useState, useEffect } from "react";
import CourseCard from "../components/CourseCard";
import { API_ENDPOINTS, apiCall } from "../config/api";

export default function Products() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    apiCall(API_ENDPOINTS.PRODUCTS.ACTIVE)
      .then((data) => {
        // console.log(data);

        setProducts(
          data.map((product) => {
            return <CourseCard key={product.id} productProp={product} />;
          })
        );
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
      });
  });

  return (
    <>
      <h1>Products</h1>
      {products}
    </>
  );
}
